<template>
  <div>
    <div class="header-2">
      <div class="page-header header-filter">
        <div 
          :style="{backgroundImage: 'url(' + options.defaultAirport.backgroundImageUrl + ')'}"
          class="page-header-image" 
          style="background-image: url('img/bg-default.png')"/>
        <div class="content-center">
          <div class="container">
            <div class="row">
              <div class="col-md-10 ml-auto mr-auto text-center">
                <h1 class="title">Confirmation</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row justify-content-center mb-4">
        <div class="col-md-10">
          <div class="row">
            <div class="col-12">
              <div class="text-center">
                <img 
                  v-lazy="`${apiUrl}reservation/barcode?reservationId=${data.id}&size=8`">
              </div>
              <h4 class="text-center mt-2">{{ data.name }}</h4>
            </div>
            <div class="col-md-6">
              <div class="row align-items-center mb-1">
                <div class="col-5">
                  Booking Date: 
                </div>
                <div class="col-7 pl-0">
                  <h5 class="font-weight-normal m-0">{{ bookingDate }}</h5>
                </div>
              </div>
              <div class="row align-items-center mb-1">
                <div class="col-5">
                  Check In: 
                </div>
                <div class="col-7 pl-0">
                  <h5 class="font-weight-normal m-0">{{ checkIn }}</h5>
                </div>
              </div>
              <div class="row align-items-center mb-1">
                <div class="col-5">
                  Check Out: 
                </div>
                <div class="col-7 pl-0">
                  <h5 class="font-weight-normal m-0">{{ checkOut }}</h5>
                </div>
              </div>
              <div class="row align-items-center mb-1">
                <div class="col-5">
                  Length: 
                </div>
                <div class="col-7 pl-0">
                  <h5 class="font-weight-normal m-0">{{ length }}</h5>
                </div>
              </div>
              <div class="row align-items-center mb-1">
                <div class="col-5">
                  Daily Rate: 
                </div>
                <div class="col-7 pl-0">
                  <h5 class="font-weight-normal m-0">${{ data.cost.maxDailyRate }}</h5>
                </div>
              </div>
              <div class="row align-items-center mb-1">
                <div class="col-5">
                  Total Daily: 
                </div>
                <div class="col-7 pl-0">
                  <h5 class="font-weight-normal m-0">${{ data.cost.totalBaseRate }}</h5>
                </div>
              </div>
              <div class="row align-items-center mb-1">
                <div class="col-5">
                  Processing Fee: 
                </div>
                <div class="col-7 pl-0">
                  <h5 class="font-weight-normal m-0">${{ data.cost.appliedProcessingFee.amount }}</h5>
                </div>
              </div>
              <div class="row align-items-center mb-1">
                <div class="col-12">
                  <el-collapse accordion>
                    <el-collapse-item name="1">
                      <template slot="title">
                        <div class="col-5">
                          <i class="bx bx-plus mr-1" />
                          <i class="bx bx-minus mr-1" />
                              
                          Location Fees: 
                        </div>
                        <div class="col-7 pl-0">
                          <h5 class="font-weight-normal m-0">${{ data.cost.totalFees }}</h5>
                        </div>
                      </template>
                      <ul>
                        <li 
                          v-for="fee in data.cost.fees"
                          :key="fee.id">
                          <div class="row align-items-center">
                            <div class="col-5">
                              {{ fee.description }}:
                            </div>
                            <div class="col-7 pl-0">
                              <h5 class="font-weight-normal m-0">${{ fee.amount }}</h5>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </el-collapse-item>
                  </el-collapse>
                </div>
              </div>
              <div class="row align-items-center mb-1">
                <div class="col-5">
                  Total: 
                </div>
                <div class="col-7 pl-0">
                  <h5 class="font-weight-bold m-0">${{ data.cost.totalRate }}</h5>
                </div>
              </div>
            </div>
            <div class="col-md-6 text-right">
              <n-button
                type="info"
                link
                class="m-0 px-0"
                @click.native="directions">
                Directions
                <i class="bx bxs-chevron-right" />
              </n-button>
              <gmap-map
                ref="gMap"
                :center="{
                  lat: data.coordinate.coordinates[1],
                  lng: data.coordinate.coordinates[0]
                }"
                :options="{scrollwheel: false}"
                :zoom="15"
                class="map">
                <gmap-marker 
                  :position="{
                    lat: data.coordinate.coordinates[1],
                    lng: data.coordinate.coordinates[0]
                }"/> 
              </gmap-map>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import moment from 'moment';
  import { mapState, mapMutations } from 'vuex';
  import { Collapse as ElCollapse, CollapseItem as ElCollapseItem, Notification } from 'element-ui';
  import { Button, FormGroupInput } from '@/components';

  export default {
    components: {
      [Button.name]: Button,
      [FormGroupInput.name]: FormGroupInput,
      [ElCollapse.name]: ElCollapse,
      [ElCollapseItem.name]: ElCollapseItem,
    },
    props: {
      data: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        apiUrl: process.env.VUE_APP_API_URL
      }
    },
    computed: {
      ...mapState([
        'options'
      ]),
      bookingDate() {
        return moment(this.data.modified).format('MM/DD/YYYY HH:mm A');
      },
      checkIn() {
        return moment(this.data.startDate + ' ' + this.data.startTime).format('MM/DD/YYYY HH:mm A');
      },
      checkOut() {
        return moment(this.data.endDate + ' ' + this.data.endTime).format('MM/DD/YYYY HH:mm A');
      },
      length() {
        const diff = moment(new Date(this.data.endDate + ' ' + this.data.endTime)).diff(moment(new Date(this.data.startDate + ' ' + this.data.startTime)), 'minutes');
        const days = Math.floor(diff / 60 / 24);
        const hours = Math.floor((diff - days * 60 * 24) / 60);
        const mins = diff - days * 24 * 60 - hours * 60;
        
        let length = days + 'Days ';
        if (hours > 0) {
          length += hours + 'Hrs '
        }
        if (mins > 0) {
          length += mins + 'Mins';
        }

        return length.trim();
      }
    },
    created() {
      this.setLoading(false);
    },
    methods: {
      ...mapMutations([
        'setLoading'
      ]),
      directions() {
        const aTag = document.createElement('a');
        aTag.href = `http://maps.google.com/maps?q=${this.data.coordinate.coordinates[1]},${this.data.coordinate.coordinates[0]}`
        aTag.target = '_blank';
        aTag.click();
      },
    }
  }
</script>
<style lang='scss' scoped>
  .page-header {
    min-height: 25vh !important;

    .page-header-image {
      background-position: center center !important;
    }

    .container {
      text-align: left !important;

      .title {
        @media (max-width: 771px) {
          font-size: 2.25em;
        }
      }
    }
  }

  ::v-deep .el-collapse {
    border: 0 !important;

    .el-collapse-item__header {
      height: auto !important;
      line-height: unset !important;
      font-size: inherit !important;
      margin-bottom: 4px;
      border: 0 !important;
      margin-left: -15px;
      margin-right: -15px;

      .bx-plus {
        display: inline-block;
      }
      .bx-minus {
        display: none;
      }

      &.is-active {
        .bx-plus {
          display: none;
        }
        .bx-minus {
          display: inline-block;
        }
      }
    }

    .el-collapse-item__wrap {
      border: 0 !important;

      .el-collapse-item__content {
        padding-bottom: 4px;
      }
    }

    .el-collapse-item__arrow {
      display: none;
    }
  }
  .map {
    height: calc(100% - 34px);

    @media (max-width: 576px) {
      height: 50vh;
    }
  }
</style>
